import { render, staticRenderFns } from "./ArticleListPopup.vue?vue&type=template&id=4b4a60ca&scoped=true&"
import script from "./ArticleListPopup.vue?vue&type=script&lang=js&"
export * from "./ArticleListPopup.vue?vue&type=script&lang=js&"
import style0 from "./ArticleListPopup.vue?vue&type=style&index=0&id=4b4a60ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4a60ca",
  null
  
)

export default component.exports